/** Ishga tushish vaqtida aniqlanadigan holat (main.tsx to'ldiradi). */
export const runtime = {
  /** Dev: Telegram tashqarisida, soxta muhit — auth `/auth/dev` orqali. */
  mocked: false,
  /** Dev mock foydalanuvchisi (seed telegramId). */
  mockTelegramId: 0,
};
